module.exports = __webpack_public_path__ + "static/media/message_short.mp3?c2a2a00ba3bf1c4472ef04835ecb1c4a";